export function safeNumber(value: number): number {
  return Number.isNaN(value) || !Number.isFinite(value) ? 0 : value;
}
